<template>
  <div class="headerBox">
    <div class="headerBox_content">
      <div class="header_navBox">
        <img src="static/image/logo.png" alt="">
        <div class="header_navTxt">
            <span class="header_tab_item space_logo" @click="activeNavChange(1)">
              <span class="header_tab_item_normal" :class="{'header_tab_item_active':activeNav==1}">
                首页
              </span>
            </span>
          <span class="header_tab_item" @click="activeNavChange(2)">
              <span class="header_tab_item_normal" :class="{'header_tab_item_active':activeNav==2}">
                产品方案
              </span>
            </span>
          <span class="header_tab_item"  @click="activeNavChange(3)">
              <span class="header_tab_item_normal" :class="{'header_tab_item_active':activeNav==3}">
                云训练
              </span>
            </span>
          <span class="header_tab_item" @click="activeNavChange(4)">
              <span class="header_tab_item_normal" :class="{'header_tab_item_active':activeNav==4}">
                云现场
              </span>
            </span>
          <span class="header_tab_item" @click="activeNavChange(5)">
              <span class="header_tab_item_normal" :class="{'header_tab_item_active':activeNav==5}">
                管理后台
              </span>
            </span>
          <span class="header_tab_item" @click="activeNavChange(6)">
              <span class="header_tab_item_normal" :class="{'header_tab_item_active':activeNav==6}">
                易管通4.0
              </span>
            </span>
          <span class="header_tab_item" @click="activeNavChange(7)">
              <span class="header_tab_item_normal" :class="{'header_tab_item_active':activeNav==7}">
                管廊管理
              </span>
            </span>
        </div>
      </div>
      <div>
        <img class="phone_imgSize" src="static/image/phone.png" alt="">
        <span>4000-119-329</span>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "headerCom",
      data(){
        return{
          activeNav: '1',
        }
      },
      created(){
          this.getActiveTab();
      },
      methods: {
          getActiveTab(){
            let currentPath = this.$route.path;
            if(currentPath == '/indexPage'){
              this.activeNav = 1;
            }else if(currentPath == '/productPage'){
              this.activeNav = 2;
            }else if(currentPath == '/doubleRandom'){
              this.activeNav = 2;
            }else{
              this.activeNav = 2;
            }
          },
        activeNavChange(index) {
          if (index == 1) {
            this.activeNav = 1;
            this.$router.push({
              name: "IndexPage"
            }).catch(err => {
              // console.log('输出报错', err)
            })
          } else if (index == 2) {
            this.activeNav = 2;
            this.$router.push({
              name: "ProductPage"
            }).catch(err => {
              // console.log('输出报错', err)
            })
          } else if (index == 3) {

          }else if (index == 4) {
            window.open("https://xffww.com/admin/#/login")
          }else if (index == 5) {
            window.open("http://xgt2014.com/msXgt/")
          }else if (index == 6) {
            window.open("http://xgt2014.com/fireV0428/pcRuning.html")
          } else if (index == 7) {
            window.open("http://xgt2014.com/duct/login.html")
          } else {

          }
        },

      }
    }
</script>

<style scoped>
  /*头部nav样式*/
  .headerBox{
    width: 100%;
    height: 70px;
    color: #fff;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 22;
  }
  .headerBox_content{
    width: 1200px;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    box-sizing: border-box;
  }
  .header_navBox{
    display: flex;
    height: 100%;
    align-items: center;
  }
  .header_navTxt{
    height: 100%;
    cursor: pointer;
  }
  .logo_size{
    font-size:18px;
    font-family:DIN;
    font-weight:500;
    color:rgba(231,238,254,1);
  }
  .header_tab_item{
    font-size: 16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(231,238,254,1);
    padding: 0 30px;
    display: inline-block;
    height: 100%;
    line-height: 50px;
    box-sizing: border-box;
  }
  .header_tab_item:hover>.header_tab_item_normal{
    color: rgba(42,98,255,1);
    /*border-bottom: 2px solid rgba(42,98,255,1);*/
  }
  .space_logo{
    padding: 0 35px 0 70px;
  }
  .phone_imgSize{
    display: inline-block;
    width: 16px;
    height: 16px;
  }
  .header_tab_item_normal{
    display: inline-block;
    height: 100%;
    line-height: 70px;
    box-sizing: border-box;
    border-bottom: 2px solid rgba(42,98,255,0);
  }
  .header_tab_item_active{
    border-bottom: 2px solid rgba(42,98,255,1);
  }
</style>



// WEBPACK FOOTER //
// src/components/common/headerCom.vue